<template>
  <div>
    <vs-table search :data="comments">
      <div
        slot="header"
        class="flex flex-wrap-reverse items-center flex-grow justify-between"
      >
        <div
          class="flex flex-wrap-reverse items-center data-list-btn-container"
        >
          <span class="font-bold text-dark mr-8">{{ subject }}</span> &nbsp;
          <div
            @click="getList()"
            class="
              btn-add-new
              p-3
              mb-4
              mt-4
              mr-4
              rounded-lg
              cursor-pointer
              flex
              items-center
              justify-center
              text-lg
              font-medium
              text-base text-primary
              border border-solid border-primary
            "
          >
            <feather-icon icon="RefreshCwIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Actualiser</span>
          </div>
        </div>
      </div>
      <template slot="thead">
        <vs-th>Commentaire</vs-th>
        <vs-th>Auteur</vs-th>
        <vs-th>Date de création</vs-th>
        <vs-th>Nombre de signalement</vs-th>
        <vs-th>Actions</vs-th>
      </template>

      <template slot-scope="{ data }">
        <vs-tr :key="indextr" v-for="(tr, indextr) in data">
          <vs-td v-html="tr.comment"></vs-td>
          <vs-td>{{ tr.author }}</vs-td>
          <vs-td>{{ tr.created_at }}</vs-td>
          <vs-td>{{ tr.nbr_reports }}</vs-td>

          <td class="whitespace-no-wrap">
            <div class="flex">
              <vx-tooltip text="Supprimer le commentaire">
                <feather-icon
                  style="cursor: pointer"
                  @click="
                    (commentToDelete = tr),
                      (commentToDeleteIndex = indextr),
                      deleteComment()
                  "
                  icon="TrashIcon"
                  svgClasses="w-5 h-5 hover:text-primary stroke-current"
                  class="mr-2"
                />
              </vx-tooltip>
            </div>
          </td>
        </vs-tr>
      </template>
    </vs-table>
    <br />
    <vs-pagination
      v-if="last_page && page"
      :total="last_page"
      v-model="page"
    ></vs-pagination>
  </div>
</template>

<script>
import { _buildQuery } from "../../../helpers/buildquery";

export default {
  name: "Otd2ReportedComments",
  watch: {
    page(value) {
      this.getList();
    },
  },
  data() {
    return {
      last_page: null,
      page: 1,
      deleteCommentPrompt: false,
      commentToDelete: null,
      commentToDeleteIndex: null,
      comments: [],
      subject: null,
    };
  },

  mounted() {
    this.getList();
  },

  methods: {
    toggleDeleteCommentPrompt(val = fale) {
      this.deleteCommentPrompt = val;
    },
    async getList() {
      try {
        this.$vs.loading();
        let params = {
          page: this.page,
          limit: 10,
          subject_id: this.$route.params.slug,
        };
        let response = await this.$http.get(
          "forum/comments/list-reported-comments" + _buildQuery(params)
        );
        if (response.data) {
          console.log(response.data);
          this.comments = response.data.comments.data;
          this.last_page = response.data.comments.last_page;
          this.subject = response.data.subject;
          this.$vs.loading.close();
        }
      } catch (error) {
        this.$vs.loading.close();
        if (error.response.status === 401) {
          this.$vs.notify({
            title: "Erreur",
            text: "Votre session a expiré",
            color: "danger",
            iconPack: "feather",
            icon: "icon-check",
            position: "top-right",
          });
          this.$router.push({ name: "login" });
        }
      }
    },
    async deleteComment() {
      if (confirm("Souhaitez-vous vraiment supprimer ce commentaire ?")) {
        try {
          this.$vs.loading();
          let response = await this.$http.delete(
            "forum/comments/" + this.commentToDelete.slug
          );
          if (response.data) {
            //   console.log(response.data);
            this.$vs.notify({
              title: "Succès",
              text: "Commentaire supprimé avec succès",
              color: "success",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.comments.splice(this.commentToDeleteIndex, 1);
            this.$vs.loading.close();
          }
        } catch (error) {
          this.$vs.loading.close();
          if (error.response.status === 401) {
            this.$vs.notify({
              title: "Erreur",
              text: "Votre session a expiré",
              color: "danger",
              iconPack: "feather",
              icon: "icon-check",
              position: "top-right",
            });
            this.$router.push({ name: "login" });
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
</style>